<template>
  <div class="index"> 
    <TableLayout>
      <template slot="search-form">
        <section class="btn-actions">
          <div class="fl">
            <el-form ref="searchForm" @submit.native.prevent slot="search-form" :model="searchForm" label-width="86px" inline>
              <el-form-item label="课件标题" prop="title">
                <el-input v-model="searchForm.title" placeholder="请输入" @keyup.enter.native="keyDownEnter" clearable size="medium" class="item-width"></el-input>
              </el-form-item>
              <el-form-item label="课程目录" prop="directoryId">
                <el-cascader ref="cascader" :popper-append-to-body="false" popper-class="custom-dropdown"
                  v-model="searchForm.directoryId"
                  :show-all-levels="false" clearable filterable
                  :props="props" :options="directoryList"
                  @change="handleChange"
                  ></el-cascader>
              </el-form-item>
              <el-form-item label="关键字" prop="key">
                <el-input v-model="searchForm.key" placeholder="请输入" @keyup.enter.native="keyDownEnter" clearable size="medium" class="item-width"></el-input>
              </el-form-item>
              <section style="">
                <div class="search-btn" @click="search()" >搜索</div>
              </section>
            </el-form>
          </div>
          <div class="fr">
            <el-button icon="el-icon-edit" type="text" @click="handleAdd">新增课件</el-button>
          </div>
        </section>
      </template>
      <!-- 表格和分页 :height="tableHeight - (showObj ? 34 : 0)" -->
      <template slot="table-wrap">
        <el-table
          ref="tableList" :height="tableHeight"
          :row-style="selectedstyle"
          :row-class-name="tableRowClassName"
          :header-cell-style="{background:'#1e87f1', color:'#fff'}"
          v-loading="isWorking.loading"
          :data="tableData.list"
        >
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="title" label="课件标题" min-width="120px" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="directoryLevel" label="小节序号" width="100" align="center"></el-table-column>
          <el-table-column prop="directoryName" label="课程目录" min-width="180px" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="keys" label="关键字" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" min-width="200px" align="center"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="handleLook(row)">查看详情</el-button>
              <el-button type="text" @click="handleEdit(row)">编辑</el-button>
              <el-button type="text" class="delete" @click="handleDel(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="fix-footer">
          <pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange($event, { msg: true })"
            :pagination="tableData.pagination"
          ></pagination>
        </div>
      </template>
    </TableLayout>
    <Dialog
      v-model="dialogdetail" :width="'90%'" :top="'0px'"
      :title="'查看详情'" :footer="false"
      @confirm="handleConfirm"
    >
      <template slot="dialog-content">
        <coursewaredetail  ref="coursewaredetail" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { comMethod } from '@/utils/index.js'
import Pagination from '@/components/common/pagination'
import Dialog from '@/components/common/Dialog';
import BaseTable from '@/components/BaseTable'
import TableLayout from '@/layout/TableLayout'
import { questionType } from '@/data/data';
import formatter from '@/mixin/formatter.js';
import { coursewareServer, courseServer } from '@/api/api'
import coursewaredetail from './details/coursewaredetail'
export default {
  name: 'vedio',
  mixins: [formatter],
  extends: BaseTable,
  components: {TableLayout, Pagination, Dialog, coursewaredetail},
  data () {
    return {
      tableHeight: 300,
      questionType,
      dialogdetail: false,
      directoryList: [],
      searchForm: {
        title: null,
        directoryId: null,
        key: ''
      }
    }
  },
  methods: {
    keyDownEnter (e) {
      e.preventDefault(); // 阻止事件默认行为
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 13) {
        this.search();// 搜索按钮的回调
      }
    },
    /**
     * 页码变更处理
     * @function handlePageChange
     * @param { Interger } pageIndex 搜索页面
     * @param { Object } obj 搜索处理逻辑内容
     */
    handlePageChange (pageIndex, obj = {}) {
      this.isWorking.loading = true
      this.tableData.pagination.pageIndex = pageIndex
      coursewareServer.coursewareList({
        ...this.searchForm,
        page: pageIndex,
        rows: this.tableData.pagination.pageSize
      }).then(res => {
        this.isWorking.loading = false
        let { code, data, message } = res
        if (code === '0') {
          if (data) {
            this.tableData.list = data.records
            this.tableData.pagination.total = data.total || 0
          }
        } else {
          this.$message.error(message)
        }
      }).finally(() => {
        this.isWorking.loading = false
      })
    },
    handleAdd () {
      let rourteUrl = this.$router.resolve({
        path: 'addcourseIndex'
      });
      window.open(rourteUrl.href, '_blank')
    },
    handleLook (row) {
      this.rowIndex = row.index;
      this.dialogdetail = true
      this.$nextTick(() => {
        this.$refs.coursewaredetail.getDetail(row.id)
      })
    },
    handleEdit (row) {
      this.rowIndex = row.index;
      let rourteUrl = this.$router.resolve({
        path: 'addcourseIndex',
        query: {id: row.id}
      });
      window.open(rourteUrl.href, '_blank')
    },
    handleDel (row) {
      let str = '确定要删除吗？'
      this.$confirm(str, '提示', { type: 'warning' }).then(() => {
        coursewareServer.coursewareDel({
          id: row.id
        }).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功');
            this.search()
          } else {
            this.$alert(res.message, '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true
            });
          }
        }).catch((error) => {
          this.$message.error(error)
        })
      })
    },
    // 弹窗确认的回调
    handleConfirm() {
      this.dialogdetail = false
    },
    // 课程目录
    selectData () {
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.INITData(data)
          this.directoryList = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    INITData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].subList.length < 1) {
          data[i].subList = undefined // subList若为空数组，则将subList设为undefined
        } else {
          this.INITData(data[i].subList) // subList若不为空数组，则继续 递归调用 本方法
        }
      }
    },
    handleChange(value) {
      // 手动收起下拉框
      this.$nextTick(() => {
        this.$refs.cascader.dropDownVisible = false; // 收起下拉框
      })
      this.handlePageChange(1);
    },
    keyDownEnter (e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 13) {
        this.search();// 搜索按钮的回调
      }
    }
  },
  mounted () {
    this.selectData()
    this.search()
  },
  created () {
    this.tableHeight = comMethod.getTableHeight(206)
  }
}
</script>

<style scoped lang='scss'>
/deep/ .el-dialog{
  height: 100%;
}
/deep/ .el-dialog__body {
  height: calc(100% - 54px);
  max-height: 100%;
}
.body{
  width: 100%;
  height: 100%;
}
.index .btn-actions {
  .search-btn {
    display: inline-block;
    width: 60px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #D0DFFB;
    color: #0052D9;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 30px;
    margin-left: 2px;
    text-align: center;
    // &:hover {
    //   background: #0052D9;
    //   border: 1px solid #0052D9;
    //   color: #fff;
    // }
  }
  /deep/ .el-input__inner {
    font-family: PingFang SC;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #D0DFFB;
    // color: #AAB4D2;
  }
  /deep/ .el-select, /deep/ .el-cascader {
    .el-input__inner {
      width: 160px;
      border-radius: 4px;
      color: #4F6389;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/resource/courseware.vue